
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3a3 3 0 110 6 3 3 0 010-6zM8.938 6.438a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm14.125 1.5a1 1 0 110 2 1 1 0 010-2zM6 13.75a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm20 1a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM8.938 21.063a2 2 0 11.001 3.999 2 2 0 01-.001-3.999zm14.125.5a1.5 1.5 0 11-.001 3.001 1.5 1.5 0 01.001-3.001zM16 24.25a1.75 1.75 0 11-.001 3.501A1.75 1.75 0 0116 24.25z"}})])
          )
        }
      }
    